export enum OTA_WARNING {
    NEW_GENERAL = 'NEW_GENERAL',
    EDITED_GENERAL = 'EDITED_GENERAL',
    REJECTED_GENERAL = 'REJECTED_GENERAL',
    NEW_CONTRACT = 'NEW_CONTRACT',
    EDITED_CONTRACT = 'EDITED_CONTRACT',
    REJECTED_CONTRACT = 'REJECTED_CONTRACT',
    MISSING_CONTRACT = 'MISSING_CONTRACT',
    WILL_EXPIRED_ID = 'WILL_EXPIRED_ID',
    EXPIRED_ID = 'EXPIRED_ID'
}